import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const InviteGenerator: React.FC = () => {
  return (
    <div className="min-h-screen bg-black flex items-center justify-center p-4">
      <Card className="w-full max-w-md mx-auto bg-black/95 border border-white/10 shadow-2xl">
        <CardHeader className="text-center">
          <CardTitle className="text-white text-2xl font-light">
            Generator
          </CardTitle>
        </CardHeader>
        <CardContent className="text-center text-white/70">
          <p>Invite generator is temporarily unavailable.</p>
          <p className="mt-2 text-sm">Please check back later.</p>
        </CardContent>
      </Card>
    </div>
  );
};

export default InviteGenerator;